import { AfterViewInit, Component, ElementRef, Input, OnInit } from '@angular/core';
import { Chart } from 'chart.js';

export interface GraphData {
    category: string;
    value: number;
    color: string;
}

@Component({
    selector: 'app-bar-graph',
    templateUrl: './bar-graph.component.html',
    styleUrls: ['./bar-graph.component.css']
})
export class BarGraphComponent implements OnInit, AfterViewInit {
    @Input()
    dataSet: GraphData[];

    private elementRef: ElementRef;
    constructor(elementRef: ElementRef) {
        this.elementRef = elementRef;
    }
    context : any

    ngOnInit(): void {
    }
    
    ngAfterViewInit() {
        this.context = this.elementRef.nativeElement.querySelector('#assetPerformanceBarGraphCanvas');
        this.drawGraph(this.dataSet);
    }

    drawGraph(dataSet: GraphData[]) {
        return new Chart(this.context, {
            type: 'bar',
            data: {
                labels: dataSet.map((item) => item.category),
                datasets: [{
                    data: dataSet.map((item) => item.value),
                    backgroundColor: dataSet.map((item) => item.color),
                }]
            },
            options: {
                legend: {
                    display: false
                },
                scales: {
                    xAxes: [{
                        maxBarThickness: 22,
                        ticks: {
                            fontSize: 8,
                        },
                        gridLines: {
                            display: false
                        }
                    }],
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            stepSize: 10,
                            callback: function (value) {
                                return value + '%';
                            }
                        }
                    }]
                },
                tooltips: {
                    callbacks: {
                        title: function () {
                            return '';
                        },
                        label: function (tooltipItem, data) {
                            const index = tooltipItem.index;
                            const barLabel = data.labels[index] === 'Finzy' ?  'Your ROI' :data.labels[index].toString().replace(',', ' ');
                            const barValue = data.datasets[0].data[index];
                            return barLabel + ' : ' + barValue + '%';
                        },
                    }
                }
            },
        });
    }
}
